import { includes, some, union, without } from "lodash";
import React from "react";
import { Box, FormGroup } from "@mui/material";
import { CheckboxBasic } from "components/common/form";
import { InterestStage, STATUSES_INACTIVE } from "model/interest/status";
import { FiltersState } from "./state";

const STATUSES_ROOT = ["Active", InterestStage.Removed, InterestStage.MovedIn];

const isStatusChecked = (state: FiltersState, statuses: string[], status: string) => {
  if (includes(state.statuses, status)) {
    return true;
  }

  if (status === "Active") {
    return some(state.statuses, (statusItem) => includes(statuses, statusItem));
  }

  return false;
};

type CheckboxProps = {
  state: FiltersState;
  onChange: (status: string, checked: boolean) => void;
  statuses: string[];
  status: string;
}

const Checkbox: React.FC<CheckboxProps> = ({ state, status, statuses, onChange, ...props }) => {
  const enabled = isStatusChecked(state, statuses, status);
  return (
    <CheckboxBasic
      name={status}
      label={status}
      style={{ marginLeft: -16 }}
      labelStyle={{ marginLeft: 0, paddingLeft: 8 }}
      checked={enabled}
      onChangeAction={() => {
        onChange(status, !enabled);
      }}
      {...props}
    />
  );
};

type Props = {
  state: FiltersState;
  stages: string[];
  onChange: (names: string[]) => void;
}

const FilterStatuses: React.FC<Props> = (props) => {
  const candidates = without(props.stages, ...STATUSES_INACTIVE);

  React.useEffect(() => {
    // if no status filter is selected on load
    // set active by default to show some results
    if (props.state.statuses.length === 0) {
      props.onChange(candidates);
    }
  }, []);

  const onChangeStatus = (status: string, checked: boolean) => {
    const statuses = (() => {
      const newStatuses = status === "Active" ? candidates : [status];
      return checked ? (
        union(props.state.statuses, newStatuses)) : without(props.state.statuses, ...newStatuses);
    })();

    props.onChange(statuses);
  };

  const commonProps = {
    state: props.state,
    statuses: candidates,
    onChange: onChangeStatus,
    sx: { my: 0.15 },
  };

  return (
    <>
      {STATUSES_ROOT.map((status) => (
        status === "Active" ? (
          <Box key={status}>
            <Checkbox {...commonProps} status={status} />
            <FormGroup sx={{ ml: 2 }}>
              {candidates.map((stage) => (
                <Checkbox key={stage} {...commonProps} status={stage} />
              ))}
            </FormGroup>
          </Box>
        ) : (
          <Checkbox key={status} {...commonProps} status={status} />
        )
      ))}
    </>
  );
};

export default FilterStatuses;
